import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const satelliteRoutes: Route = {
    path: 'satellite',
    data: { title: 'satellite' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'planet-plan' },
        {
            path: 'planet-plan',
            loadComponent: () => import('./planet-plan/planet-plan.component').then((m) => m.PlanetPlanComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'planet-plan' },
        },
        {
            path: 'planet-order',
            loadComponent: () => import('./planet-order/planet-order.component').then((m) => m.PlanetOrderComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Planet order' },
        },
        {
            path: 'planet-record',
            loadComponent: () => import('./planet-record/planet-record.component').then((m) => m.PlanetRecordComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Planet record' },
        },
        {
            path: 'satellite-type',
            loadComponent: () =>
                import('./satellite-type/satellite-type.component').then((m) => m.SatelliteTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Satellite type' },
        },
        {
            path: 'sentinel-record',
            loadComponent: () =>
                import('./sentinel-record/sentinel-record.component').then((m) => m.SentinelRecordComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Sentinel record' },
        },
        {
            path: 'satellite-images',
            loadComponent: () =>
                import('./satellite-images/satellite-images.component').then((m) => m.SatelliteImagesComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Satellite images' },
        },
    ],
};
